import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews } from "@/utils/format";

interface HotRankingProps {
  videos: Video[];
}

export default function HotRanking({ videos }: HotRankingProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
          <i className="ri-bar-chart-2-line"></i>
        </span>
        <h3 className="font-heading text-base font-black text-foreground-950">
          热门视频排行
        </h3>
      </div>
      <ol className="flex flex-col divide-y divide-background-200">
        {videos.map((video, i) => (
          <li key={video.id}>
            <Link
              to={`/detail/${video.id}`}
              className="flex items-center gap-3 py-3 cursor-pointer group"
            >
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-black ${
                  i === 0
                    ? "bg-primary-500 text-background-50"
                    : i === 1
                      ? "bg-accent-500 text-background-50"
                      : "bg-secondary-100 text-secondary-900"
                }`}
              >
                {i + 1}
              </span>
              <div className="h-12 w-20 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={video.cover}
                  alt={`${video.title} 缩略图`}
                  title={`${video.title} - 黑料视频`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-600">
                  {video.title}
                </p>
                <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-play-circle-line"></i>
                  {formatViews(video.views)}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}